/**
 * Existing Form Handler - Makes your current form submit to Google Sheets
 * No design changes needed - works with your existing HTML/CSS
 */

(function() {
    'use strict';

    // Configuration
    const CONFIG = {
        googleSheetsURL: 'https://script.google.com/macros/s/AKfycbyPdkEC-ZMVZl9vLzyrIVgyTx4Ie5pINFyEeuZG3SiXAkefKQzvkKLa3K3dfmmi92jj/exec', // Add your Google Sheets Web App URL here
        formSelector: '.contact-form-cover form', // Your form selector
        sheetName: 'Birthday Returns New', // Sheet tab name in Google Spreadsheet
    };

    function init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', setupForm);
        } else {
            setupForm();
        }
    }

    function setupForm() {
        const form = document.querySelector(CONFIG.formSelector);
        
        if (!form) {
            console.log('Contact form not found');
            return;
        }

        console.log('Contact form found, attaching handler...');

        // Replace Number of Units input with dropdown
        replaceNumberOfUnitsWithDropdown(form);

        // Replace Inquiry For input with dropdown
        replaceInquiryForWithDropdown(form);

        // Create success message element
        createSuccessMessage(form);

        // Phone input validation - only digits, max 10
        const phoneInput = form.querySelector('#phone');
        if (phoneInput) {
            phoneInput.setAttribute('type', 'tel');
            phoneInput.setAttribute('autocomplete', 'off');
            phoneInput.setAttribute('maxlength', '10');
            phoneInput.setAttribute('pattern', '[0-9]{10}');
            
            phoneInput.addEventListener('input', function() {
                this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);
            });
        }

        // Email - disable autocomplete
        const emailInput = form.querySelector('#email');
        if (emailInput) {
            emailInput.setAttribute('autocomplete', 'off');
        }

        // Handle form submission
        form.addEventListener('submit', async function(e) {
            e.preventDefault();

            // Get form values
            const name = form.querySelector('#name')?.value.trim() || '';
            const phone = form.querySelector('#phone')?.value.trim() || '';
            const email = form.querySelector('#email')?.value.trim() || '';
            const units = form.querySelector('#nou')?.value.trim() || '';
            const inquiry = form.querySelector('#if')?.value.trim() || '';
            const message = form.querySelector('#message')?.value.trim() || '';

            // Validate
            if (!name) {
                alert('Please enter your name');
                return;
            }

            if (!phone) {
                alert('Please enter your phone number');
                return;
            }

            if (phone.length !== 10) {
                alert('Phone number must be exactly 10 digits');
                return;
            }

            if (!/^[0-9]{10}$/.test(phone)) {
                alert('Phone number must contain only digits');
                return;
            }

            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                alert('Please enter a valid email address');
                return;
            }

            if (!units) {
                alert('Please enter number of units');
                return;
            }

            if (!inquiry) {
                alert('Please enter inquiry type');
                return;
            }

            // Prepare data
            const formData = {
                name: name,
                phone: phone,
                email: email,
                units: units,
                inquiry: inquiry,
                message: message,
                sheetName: CONFIG.sheetName,
                timestamp: new Date().toISOString(),
                source: window.location.href
            };

            // Get submit button
            const submitBtn = form.querySelector('button[type="submit"]');
            const originalText = submitBtn ? submitBtn.textContent : '';

            try {
                // Show loading
                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.textContent = 'Submitting...';
                }

                // Submit to Google Sheets
                if (CONFIG.googleSheetsURL) {
                    await fetch(CONFIG.googleSheetsURL, {
                        method: 'POST',
                        mode: 'no-cors',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(formData)
                    });

                    console.log('Form submitted successfully');
                    
                    // Show success message
                    showSuccessMessage(form);
                    
                    // Reset form
                    form.reset();
                } else {
                    console.error('Google Sheets URL not configured');
                    alert('Form configuration error. Please contact support.');
                }

            } catch (error) {
                console.error('Submission error:', error);
                alert('Sorry, there was an error submitting your form. Please try again.');
            } finally {
                // Restore button
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalText;
                }
            }
        });

        console.log('Contact form handler attached successfully');
    }

    function replaceNumberOfUnitsWithDropdown(form) {
        const nouInput = form.querySelector('#nou');
        if (!nouInput) return;

        const wrapper = nouInput.parentElement;
        
        const selectHTML = `
            <div class="rblp-select-wrapper">
                <select name="nou" id="nou" class="form-control rblp-select" required>
                    <option value="" disabled selected>Select</option>
                    <option value="20-50">20-50 Units</option>
                    <option value="50-100">50-100 Units</option>
                    <option value="100-500">100-500 Units</option>
                    <option value="500-1000">500-1000 Units</option>
                    <option value="1000+">1000+ Units</option>
                </select>
                <svg class="rblp-select-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `;

        nouInput.outerHTML = selectHTML;
        console.log('Number of Units replaced with dropdown');
    }

    function replaceInquiryForWithDropdown(form) {
        const ifInput = form.querySelector('#if');
        if (!ifInput) return;

        const selectHTML = `
            <div class="rblp-select-wrapper">
                <select name="if" id="if" class="form-control rblp-select" required>
                    <option value="" disabled selected>Select</option>
                    <option value="Birthday Gifting Program">Birthday Gifting Program</option>
                    <option value="Corporate Gifts">Corporate Gifts</option>
                    <option value="Custom Engraving">Custom Engraving</option>
                    <option value="Bulk Orders">Bulk Orders</option>
                    <option value="Other">Other</option>
                </select>
                <svg class="rblp-select-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `;

        ifInput.outerHTML = selectHTML;
        console.log('Inquiry For replaced with dropdown');
    }

    function createSuccessMessage(form) {
        const successHTML = `
            <div class="contact-form-success-message" id="contactFormSuccessMessage" style="display: none; text-align: center; padding: 40px 20px;">
                <svg style="margin-bottom: 24px;" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="32" cy="32" r="32" fill="#4CAF50"/>
                    <path d="M20 32L28 40L44 24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <h2 style="font-size: 32px; font-weight: 700; color: #4CAF50; margin-bottom: 16px;">Thank You!</h2>
                <p style="font-size: 18px; color: #666; margin-bottom: 0;">Your inquiry has been submitted successfully. Our team will get back to you shortly.</p>
            </div>
        `;

        form.insertAdjacentHTML('afterend', successHTML);
    }

    function showSuccessMessage(form) {
        const successMsg = document.getElementById('contactFormSuccessMessage');
        
        if (successMsg) {
            // Hide form
            form.style.display = 'none';
            
            // Show success message
            successMsg.style.display = 'block';
            
            // Reset after 5 seconds
            setTimeout(() => {
                form.style.display = 'block';
                successMsg.style.display = 'none';
            }, 5000);
        } else {
            // Fallback to alert if success message element not found
            alert('Thank you! Your inquiry has been submitted successfully. Our team will get back to you shortly.');
        }
    }

    // Public API to set Google Sheets URL
    window.ContactFormHandler = {
        setGoogleSheetsURL: function(url) {
            CONFIG.googleSheetsURL = url;
            console.log('Google Sheets URL updated');
        }
    };

    // Initialize
    init();

})();
